import { render, staticRenderFns } from "./CrossListedCourses.vue?vue&type=template&id=382f5883"
import script from "./CrossListedCourses.vue?vue&type=script&lang=js"
export * from "./CrossListedCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports